import React from 'react';

import {withWidgetContext} from '../widgetContextProvider';

import UtilsService from '../../../services/utilsService';
import {
  ListeningRoomService,
  ShoutingRoomService,
} from '../../../services/websocketService';
import multiWidgetService from '../../../services/multiWidgetService';
import VisibilityHandlerService from '../../../services/visibilityHandlerService';

import VIDABOO_CONSTANTS from '../../../config/consts';
class MultiDagComponent extends React.Component {
  state = {};

  componentDidMount = () => {
    this.init();
  };
  componentDidUpdate = (prevProps) => {
    if (this.props.singleWidgetMentorId !== prevProps.singleWidgetMentorId) {
      this.sendWidgetOpenClosedStateToAllWidgetContexts();
    }
  };
  sendWidgetOpenClosedStateToAllWidgetContexts = () => {
    for (const mentorId of Object.keys(
      this.aqEnabledPeerWidgetMentorCtrlDtos,
    )) {
      const peerUserId =
        this.aqEnabledPeerWidgetMentorCtrlDtos[mentorId].extendedMentorDto
          .mentorDto.mentorOwnerId;
      this.sendWidgetOpenClosedState(
        peerUserId,
        mentorId,
        VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.MENTOR,
      );
    }
    if (this.aqEnabledPeerWidgetTeamMentorCtrlDto) {
      const teamMentorId =
        this.aqEnabledPeerWidgetTeamMentorCtrlDto.extendedMentorDto.mentorDto
          .mentorId;

      for (const mentorUserId of Object.keys(this.widgetMentorPeerUsers)) {
        this.sendWidgetOpenClosedState(
          mentorUserId,
          teamMentorId,
          VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.TEAM_MENTOR,
        );
      }
    }
  };

  componentWillUnmount = () => {
    this.deleteDoWhenVisibilityChangeListener &&
      this.deleteDoWhenVisibilityChangeListener();
    for (const mentorId of Object.keys(
      this.aqEnabledPeerWidgetMentorCtrlDtos,
    )) {
      this.deleteDoWhenMessageReceivedFromShoutingRoom[mentorId] &&
        this.deleteDoWhenMessageReceivedFromShoutingRoom[mentorId]();
    }
    if (this.waitPromiseTimeoutId) {
      window.clearTimeout(this.waitPromiseTimeoutId);
    }
  };

  init = () => {
    this.deleteDoWhenVisibilityChangeListener = {};
    this.deleteDoWhenMessageReceivedFromShoutingRoom = {};
    this.aqEnabledPeerWidgetMentorCtrlDtos =
      this.getAqEnabledPeerMentorCtrlDtos();

    this.widgetMentorPeerUsers = this.getMentorUserIdsFromWidget();
    this.aqEnabledPeerWidgetTeamMentorCtrlDto =
      !UtilsService.getIsPersonalPage() &&
      this.props.widgetDto.widgetAppCtrlDto.widgetInteractionMode !==
        VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.TEAM_LIST
        ? multiWidgetService.getFirstWidgetTeamMentorCtrlDto(
            this.props.widgetDto,
          )
        : null;

    this.myUserId = this.props.currentUser.userId;
    this.pageViewStartTime = new Date().getTime();
    this.isMobileDevice = UtilsService.isMobileDevice();

    this.registerListeners();
    this.waitForMeAvailablePromise();
  };

  getAqEnabledPeerMentorCtrlDtos = () => {
    //
    // 1) in clickntalk page - all other mentors are eliminated so we can still use the below.
    // 2) todo: add the team-chat mentor.
    let peerWidgetMentorCtrlDtos = {};
    if (this.props.widgetDto.widgetAppCtrlDto.isAqIndicationsEnabled) {
      Object.values(this.props.widgetDto.mentorsControlMapDto).forEach(
        (widgetMentorCtrlDto) => {
          if (!widgetMentorCtrlDto.disableAqIndications) {
            // aq indications are disabled per mentor. Therefore we send the information per mentor that is enabled.
            const peerMentorId =
              widgetMentorCtrlDto.extendedMentorDto.mentorDto.mentorId;
            peerWidgetMentorCtrlDtos[peerMentorId] = widgetMentorCtrlDto;
          }
        },
      );
    }

    return peerWidgetMentorCtrlDtos;
  };

  getMentorUserIdsFromWidget = () => {
    let mentorUserIds = {};
    if (this.props.widgetDto.widgetAppCtrlDto.isAqIndicationsEnabled) {
      Object.values(this.props.widgetDto.mentorsControlMapDto).forEach(
        (widgetMentorCtrlDto) => {
          if (!widgetMentorCtrlDto.disableAqIndications) {
            const mentorUserId =
              widgetMentorCtrlDto.extendedMentorDto.mentorDto.mentorOwnerId;
            mentorUserIds[mentorUserId] = widgetMentorCtrlDto;
          }
        },
      );
    }

    return mentorUserIds;
  };

  createDagMessageData = (
    connectionContextOwnerId,
    connectionContextOwnerType,
  ) => {
    let dagMsgData = {
      SubType: VIDABOO_CONSTANTS.DAG_SUBTYPES.ENDPOINT_INDICATION,
      // senderProfileName: this.props.currentUser.userId,
      senderUserId: this.myUserId,
      connectionContextOwnerType: connectionContextOwnerType,
      connectionContextOwnerId: connectionContextOwnerId,
      message: VIDABOO_CONSTANTS.ENDPOINT_INDICATION_STATES.ARRIVED,
      senderCreationTime: this.pageViewStartTime,
      sessionStartTime: this.pageViewStartTime,
      isMobileDevice: this.isMobileDevice,
      currentPage: this.props.getPageLocation(),
    };

    return dagMsgData;
  };

  createDagWidgetOpenStateMessageData = (
    connectionContextOwnerId,
    connectionContextOwnerType,
  ) => {
    const isSingleWidgetMounted = this.props.isSingleWidgetMounted;

    let dagMsgData = this.createDagMessageData(
      connectionContextOwnerId,
      connectionContextOwnerType,
    );
    dagMsgData.SubType = VIDABOO_CONSTANTS.DAG_SUBTYPES.WIDGET_OPEN_STATE;
    dagMsgData.message = isSingleWidgetMounted
      ? VIDABOO_CONSTANTS.ENDPOINT_WIDGET_OPEN_STATES.WIDGET_OPEN
      : VIDABOO_CONSTANTS.ENDPOINT_WIDGET_OPEN_STATES.WIDGET_CLOSED;

    dagMsgData.mountedConnectionContextOwnerId = isSingleWidgetMounted
      ? this.props.singleWidgetMentorId
      : null;

    return dagMsgData;
  };

  waitForMeAvailablePromise = () => {
    this.waitPromiseTimeoutId = setTimeout(() => {
      // waiting till I publish that I'm available in my shouting room (handled by authentication service).
      // otherwise, could cause mentor to fetch my availability before it's been updated to "available" hence causing false leave of page.
      // -- We are sending the information per mentor id even though there could be 2 mentors with the same userId; the reason is for more organised
      for (const mentorId of Object.keys(
        this.aqEnabledPeerWidgetMentorCtrlDtos,
      )) {
        const peerUserId =
          this.aqEnabledPeerWidgetMentorCtrlDtos[mentorId].extendedMentorDto
            .mentorDto.mentorOwnerId;

        this.sendArrivalAndOpenCloseStatuses(
          peerUserId,
          mentorId,
          VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.MENTOR,
        );
      }
      this.sendTeamMentorArrivalAndOpenCloseStatusToAllWidgetUsers();
    }, 2000);
  };

  sendTeamMentorArrivalAndOpenCloseStatusToAllWidgetUsers = () => {
    // here we need to send to all the mentors in the team (once per userId) the status of the teamMentor.
    if (this.aqEnabledPeerWidgetTeamMentorCtrlDto) {
      const teamMentorId =
        this.aqEnabledPeerWidgetTeamMentorCtrlDto.extendedMentorDto.mentorDto
          .mentorId;

      for (const mentorUserId of Object.keys(this.widgetMentorPeerUsers)) {
        this.sendArrivalAndOpenCloseStatuses(
          mentorUserId,
          teamMentorId,
          VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.TEAM_MENTOR,
        );
      }
    }
  };
  registerListeners = () => {
    for (const mentorId of Object.keys(
      this.aqEnabledPeerWidgetMentorCtrlDtos,
    )) {
      const peerUserId =
        this.aqEnabledPeerWidgetMentorCtrlDtos[mentorId].extendedMentorDto
          .mentorDto.mentorOwnerId;
      this.deleteDoWhenMessageReceivedFromShoutingRoom[mentorId] =
        ShoutingRoomService.doWhenMessageReceivedFromShoutingRoom(
          peerUserId,
          (messageFromShoutingRoom) => {
            if (
              // receive message from mentor requesting status.
              messageFromShoutingRoom.senderUserId === peerUserId &&
              messageFromShoutingRoom.messageType ===
                VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER &&
              messageFromShoutingRoom.content.SubType ===
                VIDABOO_CONSTANTS.DAG_SUBTYPES.STATUS_REQUEST
            ) {
              this.sendArrivalAndOpenCloseStatuses(
                peerUserId,
                mentorId,
                VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.MENTOR,
              );
              this.sendTeamMentorArrivalAndOpenCloseStatusToAllWidgetUsers();
            }
          },
        );
    }

    this.deleteDoWhenVisibilityChangeListener =
      VisibilityHandlerService.doWhenVisibilityChange((visibilityIsHidden) => {
        for (const mentorId of Object.keys(
          this.aqEnabledPeerWidgetMentorCtrlDtos,
        )) {
          const peerUserId =
            this.aqEnabledPeerWidgetMentorCtrlDtos[mentorId].extendedMentorDto
              .mentorDto.mentorOwnerId;

          this.sendVisibilityStatus(
            peerUserId,
            mentorId,
            VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.MENTOR,
            visibilityIsHidden,
          );
        }
        if (this.aqEnabledPeerWidgetTeamMentorCtrlDto) {
          const teamMentorId =
            this.aqEnabledPeerWidgetTeamMentorCtrlDto.extendedMentorDto
              .mentorDto.mentorId;

          for (const mentorUserId of Object.keys(this.widgetMentorPeerUsers)) {
            this.sendVisibilityStatus(
              mentorUserId,
              teamMentorId,
              VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.TEAM_MENTOR,
              visibilityIsHidden,
            );
          }
        }
      });
  };

  sendArrivalAndOpenCloseStatuses = (peerUserId, mentorId, mentorOwnerType) => {
    this.sendArrivalMessage(peerUserId, mentorId, mentorOwnerType);
    this.sendWidgetOpenClosedState(peerUserId, mentorId, mentorOwnerType);
  };
  sendVisibilityStatus = (
    peerUserId,
    mentorId, // connectionContextOwnerId
    mentorType, // connectionContextMentorType
    visibilityIsHidden,
  ) => {
    const msgObj = this.createDagMessageData(mentorId, mentorType);
    msgObj.message =
      visibilityIsHidden === true
        ? VIDABOO_CONSTANTS.ENDPOINT_INDICATION_STATES.HIDDEN
        : VIDABOO_CONSTANTS.ENDPOINT_INDICATION_STATES.VISIBLE;
    ListeningRoomService.publishToListeningRoom(
      msgObj,
      this.myUserId,
      peerUserId,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER,
    );
  };

  sendWidgetOpenClosedState = (
    peerUserId,
    mentorId, // connectionContextOwnerId
    mentorType, // connectionContextMentorType
  ) => {
    const widgetMsgObj = this.createDagWidgetOpenStateMessageData(
      mentorId,
      mentorType,
    );
    ListeningRoomService.publishToListeningRoom(
      widgetMsgObj,
      this.myUserId,
      peerUserId,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER,
    );
  };
  sendArrivalMessage = (
    peerUserId,
    mentorId, // connectionContextOwnerId
    mentorType, // connectionContextMentorType
  ) => {
    const msgObj = this.createDagMessageData(mentorId, mentorType);
    if (VisibilityHandlerService.getIsVisibilityHidden()) {
      msgObj.message = VIDABOO_CONSTANTS.ENDPOINT_INDICATION_STATES.HIDDEN;
    }
    ListeningRoomService.publishToListeningRoom(
      msgObj,
      this.myUserId,
      peerUserId,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER,
    );
  };
  // doWhenTrippleClick = () => {
  //   var firstMsgObj = this.createDagMessageData();
  //   firstMsgObj.message =
  //     VIDABOO_CONSTANTS.ENDPOINT_INDICATION_STATES.ATTENTION;
  //   for (const peerUserId of Object.keys(
  //     this.peerWidgetMentorCtrlDtosWithUserIds,
  //   )) {
  //     ListeningRoomService.publishToListeningRoom(
  //       firstMsgObj,
  //       this.myUserId,
  //       peerUserId,
  //       VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER,
  //     );
  //   }
  // };

  // registerTrippleClickAction = () => {
  //   PostMessageService.doWhenTrippleClick(this.doWhenTrippleClick);
  // };

  render() {
    return null;
  }
}

export default withWidgetContext(MultiDagComponent);
